module.exports = __webpack_public_path__ + "img/typhoon_red.e856fb35.gif";